import * as yup from 'yup'

export const schema = (): TSFixMe => {
  return yup.object().shape({
    crewUsers: yup.array().of(
      yup.object().shape({
        id: yup.string()
      })
    )
  })
}
